<template>
	<el-switch
		v-model="value"
		@change="$emit('change', value)"
		style="width: 100%; margin-top: auto; margin-bottom: auto"
		active-color="#13ce66"
		:active-text="$t('show-archivied')"
		inactive-color="#ff4949"
		:inactive-text="$t('hidden-archivied')"
	>
	</el-switch>
</template>
<script>
export default {
	name: "app-deleted-items",
	props: ["deleted_at"],
	data() {
		return {
			value: this.deleted_at
		}
	}
}
</script>
<style scoped>
.el-switch {
	font-family: "Montserrat", sans-serif;
}
</style>
